import * as angular from "angular";
import {IController} from "angular";

export class fulfillmentStepsListItemCtrl implements IController {

  step: any;
  steps: any;
  stepNumber: number;
  isSelected: any;
  items: any;
  relations: any;
  fulfillmentStatus:any;
  onSelect: Function;
  onEdit: Function;
  onSplit: Function;
  onReset: Function;
  onDispatch: Function;


  private currencySymbol: any;

  /* @ngInject */
  constructor(private tasksConstants, private splitService) {
  }

  $onInit() {
    this.currencySymbol = this.splitService.getCurrencySymbol();
  }


}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepsListItem', {
    bindings: {
      step: '<',
      steps: '<',
      fulfillmentStatus: '<',
      stepNumber: '<',
      isSelected: '<',
      items: '<',
      relations: '<',
      onSelect: '&',
      onEdit: '&',
      onSplit: '&',
      onReset: '&',
      onCancel: '&',
      onDispatch: '&'
    },
    template: require('./fulfillment-steps-list-item.html').default,
    controller: fulfillmentStepsListItemCtrl
  });
